/* HALIMARK — thème Shopify. Recherche instantanée, assistant, panier, fiche produit, filtres. */
(function () {
  'use strict';
  var HM = window.HM || {};
  var R = HM.routes || {};
  var root = (R.root || '/').replace(/\/$/, '');

  /* ---------- Utilitaires ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function cents(v) { return typeof v === 'number' ? v : Math.round(parseFloat(String(v).replace(',', '.')) * 100); }
  function money(c) {
    var fmt = HM.moneyFormat || '{{amount_with_comma_separator}} €';
    var n = (c || 0) / 100;
    function sep(num, dec, th, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return sep(n, 2, ',', '.');
        case 'amount_no_decimals': return sep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(n, 0, '.', ',');
        case 'amount_with_space_separator': return sep(n, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return sep(n, 2, "'", '.');
        default: return sep(n, 2, ' ', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  function toast(t) {
    var el = $('#toast'); if (!el) return;
    el.textContent = t; el.classList.add('on');
    clearTimeout(toast._t); toast._t = setTimeout(function () { el.classList.remove('on'); }, 2800);
  }
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ARROW = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';

  var SHADES = { 'cyan': '#00A0DF', 'magenta': '#E6007E', 'jaune': '#FFD200', 'yellow': '#FFD200', 'noir': '#1B1D22', 'black': '#1B1D22', 'cyan clair': '#7FD3F2', 'magenta clair': '#F59AC8', 'gris': '#8A8F99', 'orange': '#F18A00', 'vert': '#00A651', 'rouge': '#E3242B', 'blanc': '#FFFFFF', 'white': '#FFFFFF', 'vernis': '#E9EEF5', 'vernis (gloss)': '#E9EEF5', 'vernis gloss': '#E9EEF5', 'gloss': '#E9EEF5', 'primer': '#D9D4C7', 'argent metallise': '#B9BEC6', 'argent': '#B9BEC6' };
  function shadeHex(name) { var base = String(name || '').split(' (')[0]; return SHADES[norm(base)] || SHADES[base.toLowerCase()] || '#1B1D22'; }

  /* Vignette dessinée pour un produit sans photo (recherche, assistant, panier) */
  function tagVal(tags, prefix) {
    for (var i = 0; i < tags.length; i++) { var t = String(tags[i]); if (t.toLowerCase().indexOf(prefix) === 0) return t.slice(prefix.length).trim(); }
    return '';
  }
  function thumb(p, shade) {
    if (p.image) return '<img src="' + esc(p.image) + '" alt="" loading="lazy">';
    var tags = p.tags || [];
    var type = (p.type || '').toLowerCase();
    if (type.indexOf('imprimante') > -1) {
      return '<svg viewBox="0 0 240 150" aria-hidden="true"><rect x="16" y="34" width="208" height="46" rx="8" fill="#e8ebf1"/><rect x="16" y="34" width="208" height="16" rx="7" fill="#1a1f2d"/><rect x="184" y="64" width="30" height="10" rx="2" fill="#E03BC8"/><path d="M40 80 L40 132 M200 80 L200 132" stroke="#3a4152" stroke-width="6"/><path d="M60 80 Q120 112 180 80" fill="#fff" stroke="#d3d8e1"/></svg>';
    }
    if (tagVal(tags, 'piece:')) {
      return '<svg viewBox="0 0 120 120" aria-hidden="true"><rect x="30" y="44" width="60" height="36" rx="6" fill="#1a1f2d"/><rect x="40" y="52" width="40" height="20" rx="4" fill="#E03BC8"/></svg>';
    }
    var hex = '#1B1D22';
    if (shade && shade !== 'Default Title') hex = shadeHex(shade);
    else if (p.variants && p.variants.length > 1) hex = shadeHex(p.variants[0].option1);
    return '<svg viewBox="0 0 120 120" aria-hidden="true"><rect x="18" y="30" width="84" height="62" rx="6" fill="#1a1f2d"/><rect x="18" y="30" width="24" height="62" rx="6" fill="' + hex + '" stroke="#c9ced8" stroke-width=".5"/><rect x="98" y="52" width="10" height="18" rx="2" fill="#cfd4de"/></svg>';
  }

  /* ---------- Tiroirs ---------- */
  var scrim = $('#scrim');
  function openDrawer(sel) {
    var d = $(sel); if (!d) return;
    scrim && scrim.classList.add('on'); d.classList.add('on'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
  }
  function closeDrawers() {
    scrim && scrim.classList.remove('on');
    $$('.drawer').forEach(function (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.classList.remove('no-scroll');
  }
  scrim && scrim.addEventListener('click', closeDrawers);

  /* ---------- Panier (AJAX) ---------- */
  var cartState = null;
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || 'Erreur'); e.data = j; throw e; } return j; });
    });
  }
  function getCart() { return fetchJSON((R.cart || '/cart') + '.js').then(function (c) { cartState = c; renderCart(); return c; }); }
  function addToCart(id, qty, label) {
    return fetchJSON((R.cartAdd || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function () {
      toast('Ajouté au panier' + (label ? ' : ' + label : ''));
      return getCart();
    }).then(function () { openDrawer('#cartDrawer'); })
      .catch(function (e) { toast(e.message || "Impossible d'ajouter ce produit."); });
  }
  function changeLine(key, qty) {
    return fetchJSON((R.cartChange || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (c) { cartState = c; renderCart(); });
  }
  function renderCart() {
    var c = cartState; if (!c) return;
    var badge = $('#cartCount');
    if (badge) { badge.hidden = !c.item_count; badge.textContent = c.item_count; }
    var body = $('#cartBody'), foot = $('#cartFoot');
    if (!body || !foot) return;
    if (!c.items.length) {
      body.innerHTML = '<div class="empty" style="margin-top:10px">Votre panier est vide.<br><a class="link-more" style="margin-top:14px" href="' + root + '/collections/all">Voir le catalogue ' + ARROW + '</a></div>';
      foot.innerHTML = ''; return;
    }
    body.innerHTML = c.items.map(function (it) {
      var p = { image: it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '', type: it.product_type, tags: [] };
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) + ' · ' : '';
      return '<div class="line"><a class="thumb" href="' + esc(it.url) + '">' + thumb(p, it.variant_title) + '</a><div><a href="' + esc(it.url) + '"><b>' + esc(it.product_title) + '</b></a><span>' + variant + (it.sku ? 'Réf. ' + esc(it.sku) : '') + '</span><div class="q"><button type="button" data-line="' + esc(it.key) + '" data-qty-to="' + (it.quantity - 1) + '" aria-label="Retirer un">−</button><span class="mono">' + it.quantity + '</span><button type="button" data-line="' + esc(it.key) + '" data-qty-to="' + (it.quantity + 1) + '" aria-label="Ajouter un">+</button></div></div><div class="amt">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    var sub = c.total_price, thr = HM.freeShipping || 50000, left = Math.max(0, thr - sub);
    var vat = Math.round(sub * (HM.vat || 20) / 100);
    foot.innerHTML =
      '<div class="freeship">' + (left > 0 ? 'Plus que <b>' + money(left) + ' HT</b> pour la livraison offerte' : '<b>Livraison offerte</b> sur cette commande') + '<div class="bar"><i style="width:' + Math.min(100, sub / thr * 100) + '%"></i></div></div>' +
      '<div class="totals"><span>Sous-total HT</span><span>' + money(sub) + '</span></div>' +
      '<div class="totals"><span>TVA ' + (HM.vat || 20) + ' %</span><span>' + money(vat) + '</span></div>' +
      '<div class="totals big"><span>Total TTC estimé</span><span>' + money(sub + vat) + '</span></div>' +
      '<div class="drawer-ctas"><a class="btn btn-ghost" href="' + (R.cart || '/cart') + '">Voir le panier</a><a class="btn btn-primary" href="' + root + '/checkout">Commander</a></div>';
  }

  /* ---------- Carrousel + 3D ---------- */
  function initSlider() {
    var slider = $('#slider'); if (!slider) return;
    var slides = $$('.slide', slider), dots = $$('.dots button', slider), i = 0, timer = null;
    if (slides.length < 2) return;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function restart() {
      clearInterval(timer);
      if (!reduced && slider.getAttribute('data-autoplay') === 'true') timer = setInterval(function () { go(i + 1); }, 7000);
    }
    slider.addEventListener('click', function (e) {
      var b = e.target.closest('[data-step],[data-slide]'); if (!b) return;
      if (b.dataset.step) go(i + Number(b.dataset.step)); else go(Number(b.dataset.slide));
      restart();
    });
    slider.addEventListener('mouseenter', function () { clearInterval(timer); });
    slider.addEventListener('mouseleave', restart);
    document.addEventListener('shopify:block:select', function (e) {
      var idx = slides.indexOf(e.target); if (idx > -1) { go(idx); clearInterval(timer); }
    });
    restart();
  }
  function init3D() {
    $$('[data-stage]').forEach(function (stage) {
      var rig = $('[data-rig]', stage); if (!rig) return;
      var base = 'rotateX(8deg) rotateY(-18deg)'; rig.style.transform = base;
      if (reduced) return;
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        rig.style.transform = 'rotateX(' + (8 - y * 14) + 'deg) rotateY(' + (-18 + x * 30) + 'deg)';
      });
      stage.addEventListener('pointerleave', function () { rig.style.transform = base; });
    });
  }

  /* ---------- Catalogue (pour l'assistant) ---------- */
  var catalog = null, catalogPromise = null;
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    var all = [];
    function page(n) {
      return fetchJSON(root + '/products.json?limit=250&page=' + n).then(function (j) {
        var list = j.products || [];
        all = all.concat(list);
        if (list.length === 250 && n < 8) return page(n + 1);
        return all;
      });
    }
    catalogPromise = page(1).then(function (list) {
      catalog = list.map(function (p) {
        var tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map(function (t) { return t.trim(); });
        return {
          handle: p.handle, title: p.title, type: p.product_type || '', vendor: p.vendor, tags: tags,
          url: root + '/products/' + p.handle,
          image: p.images && p.images[0] ? p.images[0].src + (p.images[0].src.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '',
          options: (p.options || []).filter(function (o) { return o.name !== 'Title'; }),
          variants: (p.variants || []).map(function (v) { return { id: v.id, title: v.title, option1: v.option1, sku: v.sku, price: cents(v.price), available: v.available !== false }; }),
          text: norm([p.title, p.product_type, tags.join(' '), (p.variants || []).map(function (v) { return v.sku + ' ' + v.title; }).join(' '), String(p.body_html || '').replace(/<[^>]+>/g, ' ')].join(' '))
        };
      });
      return catalog;
    }).catch(function () { catalog = []; return catalog; });
    return catalogPromise;
  }
  function promoPrice(c, type) {
    var pr = HM.promo || {};
    if (!pr.pct || !type || String(type).toLowerCase() !== String(pr.type || '').toLowerCase()) return null;
    return c - Math.floor((c * pr.pct + 50) / 100);
  }
  function priceHtml(c, type, suffix) {
    var d = promoPrice(c, type);
    return d === null ? money(c) + (suffix || '') : '<s class="was">' + money(c) + '</s> ' + money(d) + (suffix || '');
  }
  function isQuote(p) { return p.tags.some(function (t) { return t.toLowerCase() === 'sur-devis'; }); }

  /* Modèles d'imprimantes : « Nom|code » */
  var MODELS = (HM.models || []).map(function (l) {
    var a = String(l).trim().split('|'); if (a.length < 2) return null;
    var m = { name: a[0].trim(), code: a[1].trim().toLowerCase() };
    if (a[2]) { try { m.re = new RegExp('(^| )(' + a[2].trim() + ')(?= |$)'); } catch (e) {} }
    return m;
  }).filter(Boolean);
  var UV_CODES = MODELS.filter(function (m) { return /uv/i.test(m.name); }).map(function (m) { return m.code; });
  function findModel(q) {
    var n = ' ' + norm(q) + ' ';
    var codes = MODELS.slice().sort(function (a, b) { return b.code.length - a.code.length; });
    for (var i = 0; i < codes.length; i++) {
      var m = codes[i];
      if (m.re) { if (m.re.test(n)) return m; continue; }
      if (m.code === 'vsi') { if (/ vs ?\d{3}i /.test(n)) return m; continue; }
      if (new RegExp(' ' + m.code.replace(/[^a-z0-9]/g, '') + '(?= |\\d)').test(n)) {
        if (m.code === 'vs' && / vs ?\d{3}i /.test(n) && MODELS.some(function (x) { return x.code === 'vsi'; })) continue;
        return m;
      }
    }
    return null;
  }
  function fits(p, code) {
    var t = p.tags.map(function (x) { return x.toLowerCase().replace(/\s+/g, ''); });
    if (t.indexOf('compat:' + code) > -1 || t.indexOf('compat:all') > -1) return true;
    if (t.indexOf('compat:all-ecosol') > -1) return UV_CODES.indexOf(code) === -1;
    if (t.indexOf('compat:all-uv') > -1) return UV_CODES.indexOf(code) > -1;
    return false;
  }
  function familyOf(p) { var f = tagVal(p.tags, 'famille:'); return f || p.title; }
  function kindOf(p) {
    var ty = p.type.toLowerCase();
    if (tagVal(p.tags, 'piece:')) return 'piece';
    if (ty.indexOf('imprimante') > -1) return 'imprimante';
    if (ty.indexOf('encre') > -1) return 'encre';
    return 'autre';
  }
  var SHADE_WORDS = ['rose fluo', 'jaune fluo', 'violet', 'cyan clair', 'magenta clair', 'noir clair', 'cyan', 'magenta', 'jaune', 'noir', 'gris', 'orange', 'vert', 'rouge', 'blanc', 'vernis', 'primer', 'argent'];
  var SHADE_ALIAS = { 'blanche': 'blanc', 'noire': 'noir', 'grise': 'gris', 'verte': 'vert', 'white': 'blanc', 'black': 'noir', 'yellow': 'jaune', 'red': 'rouge', 'gloss': 'vernis', 'light cyan': 'cyan clair', 'light magenta': 'magenta clair', 'fluo pink': 'rose fluo', 'fluor pink': 'rose fluo', 'fluo yellow': 'jaune fluo', 'fluor yellow': 'jaune fluo', 'rose': 'rose fluo' };
  function findShade(q) {
    var n = ' ' + norm(q) + ' ';
    Object.keys(SHADE_ALIAS).forEach(function (k) { n = n.replace(' ' + k + ' ', ' ' + SHADE_ALIAS[k] + ' '); });
    for (var i = 0; i < SHADE_WORDS.length; i++) if (n.indexOf(' ' + SHADE_WORDS[i] + ' ') > -1) return SHADE_WORDS[i];
    return '';
  }
  function pickVariant(p, shade) {
    if (shade) {
      var ns = norm(shade), i;
      for (i = 0; i < p.variants.length; i++) if (norm(p.variants[i].option1).indexOf(ns) === 0) return p.variants[i];
      for (i = 0; i < p.variants.length; i++) if (norm(p.variants[i].option1).indexOf(ns) > -1) return p.variants[i];
    }
    for (var j = 0; j < p.variants.length; j++) if (p.variants[j].available) return p.variants[j];
    return p.variants[0];
  }
  function search(q, limit) {
    var toks = norm(q).split(' ').filter(function (t) { return t.length > 1; });
    if (!toks.length) return [];
    return catalog.map(function (p) {
      var s = 0; toks.forEach(function (t) { if (p.text.indexOf(t) > -1) s += (norm(p.title).indexOf(t) > -1 ? 3 : 1); });
      return { p: p, s: s };
    }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s; }).slice(0, limit || 4).map(function (x) { return x.p; });
  }
  var PROBLEMS = [
    { re: /trainee|bande|buse|bouche|ligne|manque/, parts: ['wiper', 'cap', 'clean', 'damper'], txt: "Des traînées ou des bandes après nettoyage viennent souvent de wipers usés ou d'un cap top qui ne fait plus l'étanchéité. Remplacez les deux et faites un nettoyage manuel avec le kit. Si le défaut persiste sur une seule couleur, vérifiez le damper de cette couleur." },
    { re: /decoupe|decale|lame|coupe|couteau/, parts: ['blade', 'roller'], txt: "Une découpe décalée ou incomplète vient le plus souvent d'une lame émoussée ou de rouleaux presseurs usés qui laissent glisser le support. Commencez par la lame, puis contrôlez les rouleaux." },
    { re: /fuite|goutte|tache/, parts: ['damper', 'cap'], txt: "Une fuite ou des gouttes d'encre viennent généralement d'un damper fatigué ou d'un cap top abîmé." }
  ];
  function skuMatch(q) {
    var nq = norm(q).replace(/ /g, '');
    if (nq.length < 4) return null;
    for (var i = 0; i < catalog.length; i++) {
      for (var j = 0; j < catalog[i].variants.length; j++) {
        var sku = norm(catalog[i].variants[j].sku).replace(/ /g, '');
        if (sku && (nq === sku || (' ' + norm(q) + ' ').indexOf(' ' + norm(catalog[i].variants[j].sku) + ' ') > -1)) return { p: catalog[i], v: catalog[i].variants[j] };
      }
    }
    return null;
  }
  function localAnswer(q) {
    var n = norm(q), model = findModel(q), shade = findShade(q);
    var hit = skuMatch(q);
    var exact = hit && norm(q).replace(/ /g, '') === norm(hit.v.sku).replace(/ /g, '');
    if (hit && (exact || kindOf(hit.p) !== 'imprimante')) return { t: 'Voici la référence ' + hit.v.sku + '.', items: [{ p: hit.p, v: hit.v }] };
    for (var i = 0; i < PROBLEMS.length; i++) {
      if (PROBLEMS[i].re.test(n)) {
        var parts = catalog.filter(function (p) { return PROBLEMS[i].parts.indexOf(tagVal(p.tags, 'piece:').toLowerCase()) > -1 && (!model || fits(p, model.code)); });
        return { t: PROBLEMS[i].txt + (model ? ' Voici les pièces compatibles avec votre ' + model.name + '.' : ''), items: parts.slice(0, 4).map(function (p) { return { p: p }; }) };
      }
    }
    if (model) {
      var wantPart = /piece|entretien|wiper|cap|rouleau|lame|damper|maintenance/.test(n);
      var allInks = catalog.filter(function (p) { return kindOf(p) === 'encre' && fits(p, model.code) && !/nettoyage|cleaning/i.test(p.title); })
        .sort(function (a, b) { return (/^kit/i.test(a.title) ? 1 : 0) - (/^kit/i.test(b.title) ? 1 : 0); });
      var inks = allInks.filter(function (p) { return !shade || !/^kit/i.test(p.title) && p.variants.some(function (v) { return norm(v.option1).indexOf(norm(shade)) > -1; }); });
      var shadeMissing = false;
      if (shade && !inks.length && allInks.length) { inks = allInks; shadeMissing = true; }
      if (!shade || shadeMissing) {
        var seenFam = {};
        inks = inks.filter(function (p) { var f = familyOf(p) + '|' + tagVal(p.tags, 'volume:'); if (seenFam[f]) return false; seenFam[f] = 1; return true; });
      }
      var parts2 = catalog.filter(function (p) { return kindOf(p) === 'piece' && fits(p, model.code) && !isQuote(p); })
        .sort(function (a, b) { var ea = a.tags.join(' ').toLowerCase().indexOf('compat:' + model.code) > -1 ? 0 : 1, eb = b.tags.join(' ').toLowerCase().indexOf('compat:' + model.code) > -1 ? 0 : 1; return ea - eb; });
      if (wantPart && parts2.length) return { t: "Voici les pièces d'entretien compatibles avec votre " + model.name + '.', items: parts2.slice(0, 4).map(function (p) { return { p: p }; }) };
      if (inks.length) {
        var fams = inks.map(familyOf).filter(function (v, k, a) { return a.indexOf(v) === k; });
        var t = 'Pour une ' + model.name + ', la famille d\'encre compatible est ' + fams.join(' ou ') + '.';
        if (shadeMissing) { t += ' La teinte ' + shade + " n'existe pas dans cette famille. Précisez une autre teinte et je vous donne la référence exacte."; shade = ''; }
        else t += shade ? ' Je vous propose directement la teinte ' + shade + '.' : ' Précisez la teinte ici (ex. « magenta ») et je vous donne la référence exacte.';
        var items = inks.slice(0, 3).map(function (p) { return { p: p, shade: shade }; });
        parts2.slice(0, 1).forEach(function (p) { items.push({ p: p }); });
        return { t: t, items: items };
      }
      return { t: "Je n'ai pas encore de référence associée à la " + model.name + ' dans le catalogue. Appelez notre conseil technique' + (HM.phone ? ' au ' + HM.phone : '') + ', nous vous confirmons la bonne encre.', items: [] };
    }
    var r = search(q, 4);
    if (r.length) return { t: 'Voici les références du catalogue qui correspondent à votre demande.', items: r.map(function (p) { return { p: p, shade: shade }; }) };
    return { t: "Je n'ai pas trouvé de référence correspondante. Indiquez le modèle exact de votre imprimante (il figure sur l'étiquette à l'arrière de la machine) ou appelez notre conseil technique" + (HM.phone ? ' au ' + HM.phone : '') + '.', items: [] };
  }

  /* ---------- Assistant ---------- */
  var thread = $('#thread'), chatLog = [], busy = false;
  function scrollThread() { var c = $('#aiDrawer .content'); if (c) c.scrollTop = c.scrollHeight; }
  function addMe(t) { var d = document.createElement('div'); d.className = 'msg me'; d.textContent = t; thread.appendChild(d); scrollThread(); }
  function addBot(t, items) {
    var d = document.createElement('div'); d.className = 'msg bot';
    var html = '<div>' + esc(t).replace(/\n/g, '<br>') + '</div>';
    if (items && items.length) {
      html += '<div class="recos">' + items.map(function (it) {
        var p = it.p, v = it.v || pickVariant(p, it.shade), quote = isQuote(p);
        var shadeLbl = v && v.option1 && p.variants.length > 1 ? ' · ' + esc(v.option1) : '';
        var price = quote ? 'Sur devis' : priceHtml(v ? v.price : 0, p.type, ' HT');
        var action = quote || !v || !v.available
          ? '<a class="add" href="' + esc(p.url) + '" aria-label="Voir le produit">' + ARROW + '</a>'
          : '<button class="add" type="button" data-add="' + v.id + '" data-label="' + esc(p.title + (shadeLbl ? ' (' + v.option1 + ')' : '')) + '" aria-label="Ajouter au panier">' + PLUS + '</button>';
        return '<div class="reco"><span class="thumb">' + thumb(p, it.shade || (v && v.option1)) + '</span><a href="' + esc(p.url) + (v && p.variants.length > 1 ? '?variant=' + v.id : '') + '"><b>' + esc(p.title) + '</b><span>' + price + shadeLbl + (v && v.sku ? ' · Réf. ' + esc(v.sku) : '') + '</span></a>' + action + '</div>';
      }).join('') + '</div>';
    }
    d.innerHTML = html; thread.appendChild(d); scrollThread(); return d;
  }
  function openAI(q) {
    if (!thread) return;
    openDrawer('#aiDrawer');
    if (!thread.children.length) addBot("Bonjour, je suis l'assistant. Donnez-moi le modèle de votre imprimante ou décrivez votre besoin, et je vous indique les références du catalogue.");
    var chips = $('#aiChips');
    if (chips && !chips.children.length) chips.innerHTML = quickChips();
    loadCatalog();
    if (q) ask(q); else setTimeout(function () { var i = $('#aiInput'); i && i.focus(); }, 300);
  }
  function quickChips() {
    return (HM.quick || []).map(function (x) { x = String(x).trim(); return x ? '<button class="chip" type="button" data-ask="' + esc(x) + '">' + esc(x) + '</button>' : ''; }).join('');
  }
  function remoteAnswer(q) {
    if (!HM.aiEndpoint) return Promise.resolve(null);
    var summary = catalog.slice(0, 200).map(function (p) { return p.handle + ' | ' + p.title + ' | ' + p.tags.join(', '); }).join('\n');
    return fetchJSON(HM.aiEndpoint, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ question: q, history: chatLog.slice(-6), catalog: summary })
    }).then(function (j) {
      if (!j || typeof j.reponse !== 'string') return null;
      var items = (j.handles || j.ids || []).map(function (h) { return catalog.filter(function (p) { return p.handle === h; })[0]; }).filter(Boolean).slice(0, 4).map(function (p) { return { p: p, shade: findShade(q) }; });
      return { t: j.reponse, items: items };
    }).catch(function () { return null; });
  }
  function ask(q) {
    if (busy || !q) return; busy = true;
    addMe(q);
    var pending = addBot(''); pending.innerHTML = '<span class="typing"><i></i><i></i><i></i></span>';
    loadCatalog().then(function () { return remoteAnswer(q); }).then(function (res) {
      res = res || localAnswer(q);
      setTimeout(function () {
        pending.remove(); addBot(res.t, res.items);
        chatLog.push({ role: 'client', content: q }, { role: 'assistant', content: res.t });
        busy = false;
      }, reduced ? 0 : 350);
    });
  }
  var aiForm = $('#aiForm');
  aiForm && aiForm.addEventListener('submit', function (e) { e.preventDefault(); var i = $('#aiInput'); var v = i.value.trim(); if (!v) return; i.value = ''; ask(v); });
  $$('[data-ai-quick]').forEach(function (el) { el.innerHTML = quickChips(); });
  $$('[data-ai-prompt]').forEach(function (f) {
    f.addEventListener('submit', function (e) { e.preventDefault(); var i = f.querySelector('input'); var v = i.value.trim(); if (!v) { i.focus(); return; } i.value = ''; openAI(v); });
  });
  var fab = $('#fab'); fab && fab.addEventListener('click', function () { openAI(); });

  /* ---------- Recherche instantanée ---------- */
  var q = $('#q'), sug = $('#suggest'), sTimer = null, sCtrl = null;
  function renderSuggest(term, products) {
    var head = '<div class="s-head"><span>' + (products.length ? products.length + ' résultat' + (products.length > 1 ? 's' : '') : 'Aucun résultat direct') + '</span><span>Entrée ↵ pour tout voir</span></div>';
    var rows = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      var pr = { image: img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120' : '', type: p.type || '', tags: p.tags || [] };
      var price = p.tags && p.tags.indexOf('sur-devis') > -1 ? 'Devis' : priceHtml(cents(p.price), p.type);
      return '<a class="s-item" href="' + esc(p.url) + '"><span class="thumb">' + thumb(pr) + '</span><span><span class="nm">' + esc(p.title) + '</span><span class="meta mono">' + esc(p.type || p.vendor || '') + '</span></span><span class="pr">' + price + '</span></a>';
    }).join('');
    sug.innerHTML = head + rows + '<div class="s-foot"><span>Une question plus précise ?</span><button type="button" data-ai-q>Demander à l\'assistant : « ' + esc(term.slice(0, 40)) + ' »</button></div>';
    sug.hidden = false;
  }
  if (q && sug) {
    q.addEventListener('input', function () {
      var term = q.value.trim(); clearTimeout(sTimer);
      if (term.length < 2) { sug.hidden = true; return; }
      sTimer = setTimeout(function () {
        if (sCtrl) sCtrl.abort(); sCtrl = window.AbortController ? new AbortController() : null;
        var url = (R.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        fetch(url, sCtrl ? { signal: sCtrl.signal } : {}).then(function (r) { return r.json(); }).then(function (j) {
          var list = j && j.resources && j.resources.results && j.resources.results.products || [];
          renderSuggest(term, list);
        }).catch(function () {});
      }, 180);
    });
    q.addEventListener('keydown', function (e) { if (e.key === 'Escape') sug.hidden = true; });
    document.addEventListener('click', function (e) { if (!e.target.closest('#search')) sug.hidden = true; });
  }
  var askBtn = $('#askBtn');
  askBtn && askBtn.addEventListener('click', function () { if (sug) sug.hidden = true; openAI(q ? q.value.trim() : ''); });

  /* ---------- Fiche produit ---------- */
  function initProduct() {
    var wrap = $('[data-product]'), pj = $('#productJson'), meta = $('#productMeta');
    if (!wrap || !pj) return;
    var product = JSON.parse(pj.textContent), m = meta ? JSON.parse(meta.textContent) : {};
    var shadeIdx = m.shadeIndex, vat = m.vat || 20;
    var form = $('#productForm'), idInput = $('#variantId');
    function currentOptions() {
      var cur = product.variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || product.variants[0];
      return (cur.options || []).slice();
    }
    function selectVariant(opts) {
      var v = product.variants.filter(function (x) { return x.options.every(function (o, k) { return o === opts[k]; }); })[0];
      if (!v) return;
      if (idInput) idInput.value = v.id;
      var ht = $('[data-price-ht]'), ttc = $('[data-price-ttc]');
      var shown = promoPrice(v.price, product.type);
      if (shown === null) shown = v.price;
      if (ht) ht.textContent = money(shown);
      if (ttc) ttc.textContent = money(Math.round(shown * (100 + vat) / 100));
      var ref = $('#refCode'); if (ref) ref.textContent = v.sku || '';
      var st = $('#stockState'); if (st) st.innerHTML = v.available ? '<span class="stock"><i></i>En stock</span>' : '<span class="stock low"><i></i>Épuisé</span>';
      var btn = $('#buyBtn'); if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé'; }
      var name = $('#colorName'); if (name && shadeIdx > -1) name.textContent = v.options[shadeIdx];
      $$('[data-variant-visual]').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-variant-visual') === String(v.id)); });
      if (v.featured_media) $$('[data-media-id]').forEach(function (el) { el.classList.toggle('on', el.getAttribute('data-media-id') === String(v.featured_media.id)); });
      try { window.history.replaceState({}, '', location.pathname + '?variant=' + v.id); } catch (e) {}
    }
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('[data-shade]');
      if (b) {
        $$('#colors button').forEach(function (x) { x.classList.toggle('on', x === b); });
        var o = currentOptions(); o[shadeIdx] = b.getAttribute('data-shade'); selectVariant(o); return;
      }
      var qb = e.target.closest('[data-qty]');
      if (qb) { var i = $('#qty'); i.value = Math.max(1, (parseInt(i.value, 10) || 1) + Number(qb.getAttribute('data-qty'))); }
    });
    $$('[data-opt]', wrap).forEach(function (s) {
      s.addEventListener('change', function () { var o = currentOptions(); o[Number(s.getAttribute('data-opt'))] = s.value; selectVariant(o); });
    });
    form && form.addEventListener('submit', function (e) {
      e.preventDefault();
      var qty = Math.max(1, parseInt($('#qty').value, 10) || 1);
      addToCart(idInput.value, qty, product.title);
    });
  }

  /* ---------- Filtres de collection ---------- */
  function initCollection() {
    var box = $('[data-collection]'), list = $('#list'); if (!box || !list) return;
    var cards = $$('[data-card]', list);
    function apply() {
      function checked(f) { return $$('[data-f="' + f + '"]:checked', box).map(function (i) { return i.value; }); }
      var fam = checked('fam'), cond = checked('cond'), tech = checked('techno'), stock = checked('stock');
      var model = ($('#catModel') || {}).value || '';
      var shown = 0;
      cards.forEach(function (c) {
        var ok = (!fam.length || fam.indexOf(c.dataset.fam) > -1) &&
          (!cond.length || cond.indexOf(c.dataset.cond) > -1) &&
          (!tech.length || tech.indexOf(c.dataset.techno) > -1) &&
          (!stock.length || c.dataset.stock === '1');
        if (ok && model) {
          var cp = (c.dataset.compat || '').split(' ');
          ok = cp.indexOf(model) > -1 || cp.indexOf('all') > -1 || (cp.indexOf('all-ecosol') > -1 && UV_CODES.indexOf(model) === -1) || (cp.indexOf('all-uv') > -1 && UV_CODES.indexOf(model) > -1);
        }
        c.hidden = !ok; if (ok) shown++;
      });
      var s = ($('#sort') || {}).value || 'best';
      cards.slice().sort(function (a, b) {
        if (s === 'asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (s === 'desc') return (Number(b.dataset.price) % 999999999) - (Number(a.dataset.price) % 999999999);
        return Number(a.dataset.order) - Number(b.dataset.order);
      }).forEach(function (c) { list.appendChild(c); });
      var count = $('#count'); if (count) count.textContent = shown + ' produit' + (shown > 1 ? 's' : '');
      var nr = $('#noResult'); if (nr) nr.hidden = shown > 0 || !cards.length;
    }
    box.addEventListener('change', function (e) { if (e.target.matches('[data-f],#sort,#catModel')) apply(); });

    /* Les filtres portent sur toute la collection : on charge les pages suivantes dans la même grille */
    var pages = Number(box.getAttribute('data-pages') || 1), sectionId = box.getAttribute('data-section');
    if (pages > 1 && sectionId && window.fetch) {
      var pag = $('.pagination', box), count = $('#count');
      var base = location.pathname, params = new URLSearchParams(location.search);
      var current = Number(params.get('page') || 1), jobs = [];
      for (var pg = 1; pg <= pages; pg++) {
        if (pg === current) continue;
        (function (n) {
          var q = new URLSearchParams(params); q.set('page', n); q.set('section_id', sectionId);
          jobs.push(fetch(base + '?' + q.toString()).then(function (r) { return r.text(); }).then(function (html) {
            var d = document.createElement('div'); d.innerHTML = html;
            return $$('#list [data-card]', d);
          }).catch(function () { return []; }));
        })(pg);
      }
      Promise.all(jobs).then(function (lists) {
        lists.forEach(function (found) { found.forEach(function (c) { list.appendChild(c); }); });
        cards = $$('[data-card]', list);
        if (pag) pag.hidden = true;
        apply();
      });
    }
  }

  /* ---------- Téléchargements ---------- */
  function initDownloads() {
    var tabs = $('#dlTabs'); if (!tabs) return;
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]'); if (!b) return;
      $$('button', tabs).forEach(function (x) { x.classList.toggle('on', x === b); });
      var t = b.getAttribute('data-tab');
      $$('.dl').forEach(function (r) { r.hidden = !(t === '*' || r.getAttribute('data-cat') === t); });
    });
  }

  /* ---------- Produits associés ---------- */
  function initRelated() {
    $$('[data-related]').forEach(function (el) {
      if (el.querySelector('.grid')) return;
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var inner = d.querySelector('[data-related]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
      }).catch(function () {});
    });
  }

  /* ---------- Clics globaux ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t) return;
    if (t.hasAttribute('data-add')) { e.preventDefault(); addToCart(t.getAttribute('data-add'), 1, t.getAttribute('data-label') || ''); return; }
    if (t.hasAttribute('data-ai-open')) { e.preventDefault(); openAI(t.getAttribute('data-ai-q-terms') || ''); return; }
    if (t.hasAttribute('data-ai-q')) { e.preventDefault(); if (sug) sug.hidden = true; openAI(q ? q.value.trim() : ''); return; }
    if (t.hasAttribute('data-ask')) { e.preventDefault(); var d = $('#aiDrawer'); if (d && d.classList.contains('on')) ask(t.getAttribute('data-ask')); else openAI(t.getAttribute('data-ask')); return; }
    if (t.hasAttribute('data-close')) { closeDrawers(); return; }
    if (t.hasAttribute('data-line')) { e.preventDefault(); changeLine(t.getAttribute('data-line'), Math.max(0, Number(t.getAttribute('data-qty-to')))); return; }
    if (t.id === 'cartBtn' && $('#cartDrawer') && !document.body.classList.contains('template-cart')) { e.preventDefault(); openDrawer('#cartDrawer'); if (!cartState) getCart(); return; }
    if (t.closest('.drawer') && t.tagName === 'A' && !t.hasAttribute('target')) closeDrawers();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawers(); if (sug) sug.hidden = true; } });

  initSlider(); init3D(); initProduct(); initCollection(); initDownloads(); initRelated();
  getCart().catch(function () {});
  document.addEventListener('shopify:section:load', function () { initSlider(); init3D(); $$('[data-ai-quick]').forEach(function (el) { el.innerHTML = quickChips(); }); });
})();
